import { FC, PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';

export const HeaderSearchDropdownProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Select: {
              controlHeight: 45,

              fontFamily: 'Inter',
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </>
  );
};
